export enum ProductType {
  EARN = "earn",
  REDEEM = "redeem",
  VOUCHER = "voucher",
  CASHVOUCHER = "cash-voucher",
  COMPLIMENTARY_NIGHTS = "complimentary-nights",
}
